function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "68B717C4-CB18-40A8-8863-82D2481C6AB2@1x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-1379.000000, -579.000000)",
  fill: "#1E445C"
}, /*#__PURE__*/React.createElement("g", {
  id: "Combined-Shape",
  transform: "translate(1376.000000, 576.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,3 L10,5 L22,5 L22,3 L24,3 L24,5 L28,5 C28.5522847,5 29,5.46718113 29,6.04347826 L29,27.9565217 C29,28.5328189 28.5522847,29 28,29 L4,29 C3.44771525,29 3,28.5328189 3,27.9565217 L3,6.04347826 C3,5.46718113 3.44771525,5 4,5 L8,5 L8,3 L10,3 Z M27,13 L5,13 L5,27 L27,27 L27,13 Z M17,21 C17.5522847,21 18,21.4477153 18,22 L18,24 C18,24.5522847 17.5522847,25 17,25 L15,25 C14.4477153,25 14,24.5522847 14,24 L14,22 C14,21.4477153 14.4477153,21 15,21 L17,21 Z M11,21 C11.5522847,21 12,21.4477153 12,22 L12,24 C12,24.5522847 11.5522847,25 11,25 L9,25 C8.44771525,25 8,24.5522847 8,24 L8,22 C8,21.4477153 8.44771525,21 9,21 L11,21 Z M11,15 C11.5522847,15 12,15.4477153 12,16 L12,18 C12,18.5522847 11.5522847,19 11,19 L9,19 C8.44771525,19 8,18.5522847 8,18 L8,16 C8,15.4477153 8.44771525,15 9,15 L11,15 Z M17,15 C17.5522847,15 18,15.4477153 18,16 L18,18 C18,18.5522847 17.5522847,19 17,19 L15,19 C14.4477153,19 14,18.5522847 14,18 L14,16 C14,15.4477153 14.4477153,15 15,15 L17,15 Z M23,15 C23.5522847,15 24,15.4477153 24,16 L24,18 C24,18.5522847 23.5522847,19 23,19 L21,19 C20.4477153,19 20,18.5522847 20,18 L20,16 C20,15.4477153 20.4477153,15 21,15 L23,15 Z M8,7 L5,7 L5,11 L27,11 L27,7 L24,7 L24,9 L22,9 L22,7 L10,7 L10,9 L8,9 L8,7 Z"
}))));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.c98d6380.svg";
export { ForwardRef as ReactComponent };